import React from 'react';
import { Bell } from 'lucide-react';

const Notifications = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <Bell size={32} className="page-icon" />
        <h1 className="page-title">Notifications</h1>
      </div>
      <div className="page-content">
        <p className="page-description">View and manage your notifications.</p>
        {/* Notifications module content will go here */}
      </div>
    </div>
  );
};

export default Notifications;